import produce from 'immer';
import { AnyAction } from 'redux';

import { ACTION_NAMES } from '../../constants';
import { V3Integrations } from '../../types';

type V3IntegrationsAction = AnyAction & { crewId: number; result: { content: V3Integrations[] } };

type V3IntegrationsSliceInRedux = { integrations: V3Integrations[] };

const initialState = produce({ integrations: [] }, () => {});

// Using immer, param-reassign is actually not a problem
/* eslint-disable no-param-reassign */
export const v3IntegrationsReducer = (state = initialState, action: V3IntegrationsAction): V3IntegrationsSliceInRedux =>
  produce(state, (draft: V3IntegrationsSliceInRedux) => {
    switch (action.type) {
      case `${ACTION_NAMES.V3_LOAD_INTEGRATIONS}_SUCCESS`:
        draft.integrations = action.result.content;
        break;
      default:
      // nothing to do => immer returns the original object
    }
  });
